import Immutable from 'immutable'

import createSignup from '../../../records/Signup'

import * as constants from './constants'

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  signups: Immutable.Set(),
})

function replaceSignup(signups, signup) {
  return signups
    .filter(search => search.get('id') !== signup.get('id'))
    .add(signup)
}

export default function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case constants.RECEIVE_SIGNUPS: {
      const signups = payload.signups.reduce((result, rawSignup) => {
        const signup = createSignup(rawSignup)

        return replaceSignup(result, signup)
      }, state.get('signups'))

      return state.set('signups', signups)
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/signup/reducer.js